module.exports = __webpack_public_path__ + "static/media/SKLP_HD.e37f07f6.gif";